import {Constants} from './moduleConstants'
import {ApprenticeshipModule} from '../../../../model/apprenticeshipModule.model'

export function addModule(module: ApprenticeshipModule) {
	return {
		type: Constants.ADD_MODULE,
		payload: module
	} as const
}
export function addModules(modules: ApprenticeshipModule[]) {
	return {
		type: Constants.ADD_MODULES,
		payload: modules
	} as const
}

export function removeModules() {
	return {
		type: Constants.REMOVE_MODULES
	} as const
}
export function updateModule(module: ApprenticeshipModule) {
	return {
		type: Constants.UPDATE_MODULE,
		payload: module
	} as const
}

export function removeModule(moduleId: number) {
	return {
		type: Constants.REMOVE_MODULE,
		payload: moduleId
	} as const
}